module.exports = __webpack_public_path__ + "static/media/home_active.52234791.svg";